import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                primary: "#E8DACF",
                secondary: "#e9c68e",
                accent: "#334165",
                error: "#f44336",
                warning: "#ff9800",
                info: "#339999",
                success: "#4caf50",
                blend: "#ecf1f4",
                lightBackground: "#eff1f7",
                lightPinkBackground: "#f6f3f1",
                darkPinkBackground: "#E8DACF",
                darkPrimary: "#b58865",
                
            }
        }
    }
});
